var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.buttonClick}},[_vm._v("这里是按钮")])])
}
var staticRenderFns = []

export { render, staticRenderFns }